import React from "react";
import Header from "../components/Header";
import MainPage from "../components/MainPage";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div>
      <Header />
      <MainPage />
      <Footer />
    </div>
  );
};

export default Home;
